import url from 'url';

/*
export default function indirectEval(script: string) {
  //Indirect eval to prevent local scope access.
  //Ref. - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/eval#description
  return (1, eval)(script);
}
*/

export const generateId = () => {
    return Date.now().toString(36) + Math.random().toString(36).substring(2);
};

export const evaluateExpression = async (str: string, state: any = {}) => {
    // evaluate expression that is in {{}}
    const regex = /{{\s*((?:(?!{{|}}).\s*)*)\s*}}/gm;

    // Alternative syntax using RegExp constructor
    // const regex = new RegExp('{{\\s*(\\w+)\\s*}}', 'gm')

    let newStr = str;
    // eslint-disable-next-line no-cond-assign
    const groups = [...str.matchAll(regex)];
    for (let i = 0; i < groups.length; i++) {
        const group = groups[i];
        const expression = group[1];
        try {
            // eslint-disable-next-line no-await-in-loop
            const result = await indirectEval(state, expression);
            if (typeof result === 'string') {
                newStr = newStr.replace(group[0], result);
            } else {
                newStr = newStr.replace(group[0], JSON.stringify(result));
            }
        } catch (e) {
            //
        }

        // The result can be accessed through the `m`-variable.
        // m.forEach((match, groupIndex) => {
        //     console.log(`Found match, group ${groupIndex}: ${match}`);
        // });
    }

    return newStr;
};

export const indirectEval = async (state: any, obj: string) => {
    let stateString = '';
    Object.keys(state).forEach((key) => {
        stateString += `\nconst ${key} = ${JSON.stringify(state[key])};`;
    });
    try {
        // eslint-disable-next-line no-eval
        const result = eval?.(`"use strict"; ${stateString} (${obj})`);
        return result;
    } catch (e) {
        return undefined;
    }
};

export const indirectEvalSync = (state: any, obj: string) => {
    let stateString = '';
    Object.keys(state).forEach((key) => {
        stateString += `\nconst ${key} = ${JSON.stringify(state[key])};`;
    });
    try {
        // eslint-disable-next-line no-eval
        const result = eval?.(`"use strict"; ${stateString} (${obj})`);
        return result;
    } catch (e) {
        return undefined;
    }
};

export const convertFilterFormat = (filters: any) => {
    const filterParams: any = {};
    for (let i = 0; i < filters.length; i++) {
        const filter = filters[i];
        let value = filter.value;
        if (value === '') {
            value = null;
        }
        if (filter.operator === '==') {
            filterParams[filter.field] = { $eq: value };
        } else if (filter.operator === '!=') {
            filterParams[filter.field] = { $ne: value };
        } else if (filter.operator === '>') {
            filterParams[filter.field] = { $gt: value };
        } else if (filter.operator === '<') {
            filterParams[filter.field] = { $lt: value };
        } else if (filter.operator === '>=') {
            filterParams[filter.field] = { $gte: value };
        } else if (filter.operator === '<=') {
            filterParams[filter.field] = { $lte: value };
        }
    }
    return filterParams;
};

export const getQueryStringFilters = (query: any) => {
    const convertedFilters: any = [];
    Object.keys(query).forEach((key) => {
        if (key.indexOf('___') >= 0) {
            const [field, operator] = key.split('___');
            let convertedOperator = operator;
            if (operator === 'eq') {
                convertedOperator = '==';
            } else if (operator === 'ne') {
                convertedOperator = '!=';
            } else if (operator === 'gt') {
                convertedOperator = '>';
            } else if (operator === 'lt') {
                convertedOperator = '<';
            } else if (operator === 'gte') {
                convertedOperator = '>=';
            } else if (operator === 'lte') {
                convertedOperator = '<=';
            }
            convertedFilters.push({
                field,
                operator: convertedOperator,
                value: query[key],
            });
        }
    });
    return convertedFilters;
};

export const extractDomain = (url: string): string => {
    const regex = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:/\n?]+)/img;
    const matches = regex.exec(url);
    if (!matches || matches.length < 2) {
        return '';
    }
    return matches[1];
};

export const getServerInstanceURL = () => {
    let httpPort = '';
    let urlBase = process.env.API_URL;
    if (process.env.API_URL) {
        const parsedURL = url.parse(process.env.API_URL);
        const tmpPort = parsedURL.port;
        if (tmpPort) {
            httpPort = `:${tmpPort}`;
        }
        if (process.env.CGG_SERVER) {
            urlBase = `${parsedURL.protocol}//${process.env.CGG_SERVER}${httpPort}`;
        }
    }
    return urlBase;
};


export const compareTables = (table1: string, table2: string) => {
    if (!table1 || !table2) {
        return false;
    }
    const tables = [table1, table2];
    const parsedTables = [];
    for (let i = 0; i < tables.length; i++) {
        const table = tables[i];
        const tableRows = table.split('\r\n');
        const tableHeader = tableRows[0].split(',');
        if (tableHeader[0] === '"index"') {
            for (let i = 1; i < tableRows.length; i++) {
                const parts = tableRows[i].split(',');
                parts.shift();
                const row = parts.join(',');
                tableRows[i] = row;
            }
        }
        parsedTables.push(tableRows);
    }
    // check row count
    if (parsedTables[0].length !== parsedTables[1].length) {
        return false;
    }

    // go through each row and compare
    const usedRows = [];
    for (let i = 1; i < parsedTables[0].length; i++) {
        let found = false;
        for (let j = 1; j < parsedTables[1].length; j++) {
            if (parsedTables[0][i] === parsedTables[1][j]) {
                if (usedRows.indexOf(j) >= 0) {
                    return false;
                }
                found = true;
                usedRows.push(j);
                break;
            }
        }
        if (!found) {
            return false;
        }
    }
    return true;
};

export const cleanJsonString = (jsonString: string) => {
    let result = jsonString;

    const fixTrailingCommas = (jsonString: string) => {
        // eslint-disable-next-line no-new-func
        const jsonObj = new Function(`return ${jsonString};`)();
        return JSON.stringify(jsonObj, null, 4);
    };

    const removeInlineComments = (jsonString: string) => {
        return jsonString.replace(/\/\/.*/g, '');
    };

    const removeBlockComments = (jsonString: string) => {
        return jsonString.replace(/\/\*[\s\S]*?\*\//g, '');
    };

    const removeCodeMarkers = (jsonString: string) => {
        return jsonString.replace(/['/#]\*\*\*\*[a-zA-Z0-9_]+\*\*\*\*['/#]/g, '');
    };

    try {
        result = removeInlineComments(result);
        result = removeBlockComments(result);
        result = removeCodeMarkers(result);
        result = fixTrailingCommas(result);
    } catch (e) {
        // console.log(e);
    }
    return result;
};
